import React, { Fragment, useEffect, useState } from 'react';
import moment from "moment";
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ContactInput = ({
    header,
    contactId,
    fieldName,
    isEditable,
    currentObject,
    handleCloseInput,
    handleEditField,
    handleUpdate,
    inputRef,
    isDisabled,
    suffixOptions,
    maxLength
}) => {

    const [selectedDate, setSelectedDate] = useState(null);
    const [lengthError, setLengthError] = useState('');

    useEffect(() => {
        if (currentObject && currentObject[fieldName]) {
            setSelectedDate(moment(currentObject[fieldName]).toDate());
        }
    }, [currentObject, fieldName]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleLengthCheck = (e) => {
        if (maxLength && e.target.value.length > maxLength) {
            setLengthError(`Maximum ${maxLength} characters allowed`);
        } else {
            setLengthError('');
        }
    };

    const handleSave = () => {
        let updatedValue;

        if (fieldName === "dateOfBirth") {
            updatedValue = selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : '';
        } else {
            updatedValue = inputRef.current ? inputRef.current.value.trim() : '';
        }

        handleUpdate(fieldName, contactId, { ...currentObject, [fieldName]: updatedValue });
    };


    return (
        <div className="form-group form-row">
            <div className="col-sm-5 col-xl-4">{header}</div>
            <div className="col-sm-7 col-xl-8">
                {isEditable !== fieldName ? (
                    <Fragment>
                        {['ssn', 'driverLicense', 'taxId'].includes(fieldName) ? (
                            <a
                                onClick={() => {if (!isDisabled) handleEditField(fieldName)}}
                                data-type="text"
                                className={"editable-generic-text" + (isDisabled ? " editable-generic-text-disabled" : "")}
                            >{currentObject ? currentObject[`${fieldName}Hashed`] ? currentObject[`${fieldName}Hashed`] : 'Not provided' : 'Not provided'}
                            </a>
                        ) : (
                            <a
                                onClick={() => {
                                    if (!isDisabled) handleEditField(fieldName);
                                }}
                                data-type="text"
                                className={"editable-generic-text" + (isDisabled ? " editable-generic-text-disabled" : "")}
                            >
                                {currentObject ?
                                    (currentObject[fieldName] && (typeof currentObject[fieldName] !== "string" || currentObject[fieldName].trim()) ?
                                        (typeof currentObject[fieldName] === "object" ? currentObject[fieldName].abbreviation : currentObject[fieldName])
                                        : "Not provided")
                                    : "Not provided"}
                            </a>
                        )}
                    </Fragment>
                ) : (
                    <div style={{position: "relative", marginBottom: lengthError ? "1.25rem" : 0}}>
                    <div className="input-group input-group-editable" style={{flexWrap: "nowrap"}}>
                        {fieldName === "suffix" ? (
                            <select
                                name={fieldName}
                                className="form-control"
                                defaultValue={currentObject && currentObject[fieldName] ? currentObject[fieldName].id : ""}
                                ref={inputRef}
                                disabled={isDisabled}
                            >
                                <option value={null}>Not provided</option>
                                {suffixOptions.map((option) => (
                                    <option key={option.id} value={option.id}>{option.abbreviation}</option>
                                ))}
                            </select>
                        ) : fieldName === "dateOfBirth" ? (
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="MM/dd/yyyy"
                            className="form-control"
                            disabled={isDisabled}
                            showMonthDropdown
                            showYearDropdown
                            yearDropdownItemNumber={75}
                            scrollableYearDropdown
                            maxDate={new Date()}
                          />
                        ) : (
                            <input
                                name={fieldName}
                                className="form-control"
                                defaultValue={currentObject ? (currentObject[fieldName] || '').trim() : ''}
                                ref={inputRef}
                                disabled={isDisabled}
                                autoComplete="off"
                                onChange={handleLengthCheck}
                            />
                        )}
                        <div className="input-group-append">
                            <button
                                type="button"
                                onClick={handleSave}
                                className="btn btn-primary btn-editable-apply"
                                disabled={isDisabled || !!lengthError}
                            >
                                {!isDisabled ? (
                                    <i className="fas fa-check" />
                                ) : (
                                    <i className="fas fa-spin fa-circle-notch" />
                                )}
                            </button>
                            <button
                                type="button"
                                onClick={handleCloseInput}
                                className="btn btn-outline-secondary btn-editable-cancel"
                                disabled={isDisabled}
                            >
                                <i className="fas fa-times" />
                            </button>
                        </div>
                    </div>
                    {lengthError && (
                        <div style={{position: "absolute", top: "100%", left: 0, color: "#dc3545", fontSize: "0.8rem", marginTop: "2px", whiteSpace: "nowrap"}}>
                            {lengthError}
                        </div>
                    )}
                    </div>
                )}
            </div>
        </div>
    );
};

ContactInput.propTypes = {};

export default ContactInput;
